import { LocaleDefinition } from '@/enums/LocaleDefinition'
import { en as fusionEnglish } from '@fusion/saas-components-v3/locale'
import { createI18n, type I18nOptions } from 'vue-i18n'
import { de, en, es, fr, ja, ko, pt, zhHans, zhHant } from 'vuetify/locale'

const vuetifyMessages: Record<string, object> = {
  'de-DE': de,
  'en-US': en,
  'es-ES': es,
  'fr-FR': fr,
  'ja-JP': ja,
  'ko-KR': ko,
  'pt-BR': pt,
  'zh-CN': zhHans,
  'zh-TW': zhHant
}

const messages: I18nOptions['messages'] = {}
const appMessages = import.meta.glob('../locales/*.json', {
  eager: true,
  import: 'default'
})

for (const [path, appLocale] of Object.entries(appMessages)) {
  const locale = path.split('/').pop()?.slice(0, -5)
  if (!locale) continue

  messages[locale] = {
    ...(locale === LocaleDefinition.English.code ? fusionEnglish : {}),
    ...(appLocale as object),
    $vuetify: vuetifyMessages[locale]
  }
}

export const i18n = createI18n({
  locale: LocaleDefinition.English.code,
  fallbackLocale: LocaleDefinition.English.code,
  messages,
  legacy: false,
  globalInjection: true
})
